import React, { Fragment, PureComponent } from 'react'
import styled, { css } from 'styled-components'
// import PropTypes from 'prop-types'
import ContainerAd from '../../../../components/ContainerAd'

const Wrapper = styled.div`
  ${(props) =>
    props.adsAreBlocked &&
    css`
      display: none;
    `}
`

const StyledContainerAd = styled(ContainerAd)`
  padding-top: 0;
  margin: 0;
`

class BlockAdSingle extends PureComponent {
  render() {
    const { adIds, ...props } = this.props
    return (
      <Fragment>
        {adIds.length > 0 && (
          <Wrapper adsAreBlocked={false} {...props}>
            <StyledContainerAd adIds={adIds.slice(0, 1)} noGapEdge />
          </Wrapper>
        )}
      </Fragment>
    )
  }
}

export default BlockAdSingle
